import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import { isEmpty } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import BackButton from '@/components/buttons/BackButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import SaveButton from '@/components/buttons/SaveButton';
import DatasetWizardActionsContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from '../../components/DatasetWizardActionsContainer';
import validateDictionaries, { dictionariesDiff } from '../helper';
import DatasetWizardCancelButton from '../../containers/DatasetWizardCancelButton';
import { transformDictionaries } from '../state/state';
import { nextDatasetStepIndex } from '../../state/state';

export const validateDictionariesStep = ({ dataset }) => (
  validateDictionaries(dictionariesDiff(dataset.dictionaries, dataset.copy.dictionaries), dataset)
);

const DictionariesActions = ({
  allowAttachments,
  category,
  code,
  compact,
  dataset,
  disableEdit,
  goBack,
  goForward,
  isDirty,
  readErrors,
  saveStatus,
  update,
  updateErrors,
  template,
}) => {
  const proceedToSave = (dictionaries) => {
    const validationErrors = validateDictionaries({ dictionaries }, dataset);
    updateErrors(category, code, validationErrors);

    return validationErrors.length === 0;
  };

  const submitForm = () => {
    const { dictionaries } = dictionariesDiff(transformDictionaries(dataset.dictionaries), dataset.copy.dictionaries);

    if (!dictionaries) {
      goForward();
    } else if (proceedToSave(dictionaries)) {
      update(category, code, { dictionaries }, template);
    }
  };

  const isLast = isEmpty(nextDatasetStepIndex(dataset, { template, allowAttachments }));
  const saveIcon = compact ? 'save' : undefined;

  return (
    <DatasetWizardActionsContainer>
      {(isDirty.dictionaries || !isLast) && (<DatasetWizardCancelButton category={category} code={code} />)}
      <BackButton onClick={goBack} iconOnly={compact} disabled={saveStatus === states.PENDING || disableEdit} />
      {!isDirty.dictionaries && !isLast && (
      <ForwardButton disabled={disableEdit || firstError(readErrors)} iconOnly={compact} onClick={goForward} />
      )}
      {!isDirty.dictionaries && isLast && (
      <DatasetWizardCancelButton category={category} code={code} closeMessageId="actions.finish" />
      )}
      {isDirty.dictionaries && (
      <SaveButton
        iconName={isLast ? saveIcon : 'chevron right'}
        iconOnly={compact}
        inProgress={saveStatus === states.PENDING}
        messageId={isLast ? 'actions.save.finish' : 'actions.save.next'}
        minimumDataEntryMet={!disableEdit}
        onClick={submitForm}
      />
      )}
    </DatasetWizardActionsContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionariesActions);
